(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/services/data.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/services/data.js');
"use strict";


const drawHandler = svs.components.sport.drawHandler.drawHandler;
const raceHandler = svs.components.sport.raceHandler.raceHandler;
const _svs$components$sport = svs.components.sportinfo.common.constants,
  EventTypeId = _svs$components$sport.EventTypeId,
  ParticipantTypes = _svs$components$sport.ParticipantTypes;
const getPixHandler = svs.components.sport.pixHandler.getPixHandler;
const _svs$utils$products$p = svs.utils.products.productIds,
  POWERPLAY = _svs$utils$products$p.POWERPLAY,
  CHALLENGE = _svs$utils$products$p.CHALLENGE,
  RACING = _svs$utils$products$p.RACING;
const userProduct2SubProductId = svs.components.sport.tipsenShared.userProduct2SubProductId;
const fetchDraw = async (productId, drawNumber) => await drawHandler().fetch(productId, drawNumber, false, true);
const fetchRace = async (productId, drawNumber) => await raceHandler().fetch(productId, drawNumber, false);
const createPix = async _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber,
    systemType = _ref.systemType,
    systemCost = _ref.systemCost,
    rowPrice = _ref.rowPrice,
    branding = _ref.branding,
    productSizes = _ref.productSizes,
    isPixMix = _ref.isPixMix,
    shouldGenerateNewPix = _ref.shouldGenerateNewPix;
  return await getPixHandler({
    isPixMix
  }).addProduct(productId, product => {
    if (systemType) {
      product.setSystemType(systemType);
    }
    if (rowPrice) {
      product.setRowPrice(rowPrice);
    }
    product.setDrawNumber(drawNumber);
    product.setProductId(productId);
    product.setSystemCost(systemCost);
    product.setBranding(branding);
    product.setProductSizes(productSizes);
  }).fetch({
    productId,
    shouldGenerateNewPix
  });
};
const _normalizeDrawEvent = _ref2 => {
  let event = _ref2.event,
    productId = _ref2.productId;
  const eventDescription = event.eventDescription,
    eventComment = event.eventComment,
    eventTypeId = event.eventTypeId,
    participantType = event.participantType,
    outcomes = event.outcomes;
  const _ref3 = (event === null || event === void 0 ? void 0 : event.match) || {},
    participants = _ref3.participants;
  const isPowerplayOrChallenge = [POWERPLAY, CHALLENGE].includes(productId);
  const hasParticipantsData = Array.isArray(participants) && participants.length === 2;
  const isPlayer = participantType === ParticipantTypes.Player;
  const hasOutcomes = Array.isArray(outcomes) && outcomes.every(item => item === null || item === void 0 ? void 0 : item.description);

  const result = {
    captionShort: hasParticipantsData ? participants.map(_ref4 => {
      let mediumName = _ref4.mediumName;
      return mediumName;
    }).join(' - ') : eventDescription,
    captionLong: hasParticipantsData ? participants.map(_ref5 => {
      let name = _ref5.name;
      return name;
    }).join(' - ') : eventDescription,
    homeTeamShort: hasParticipantsData ? participants[0].mediumName : '',
    homeTeamLong: hasParticipantsData ? participants[0].name : '',
    awayTeamShort: hasParticipantsData ? participants[1].mediumName : '',
    awayTeamLong: hasParticipantsData ? participants[1].name : ''
  };
  if (isPowerplayOrChallenge && hasParticipantsData) {
    if (isPlayer) {
      result.infoLine = eventComment || 'Vem gör flest mål?';
    } else if (eventComment && eventTypeId !== EventTypeId.EVENT_1X2) {
      result.infoLine = eventComment;
    }
  }
  if (hasOutcomes) {
    result.outcomesAsList = outcomes.map(_ref6 => {
      let description = _ref6.description;
      return [/[oöÖ]ver/i.test(description) && 'Ö', /under/i.test(description) && 'U', description].find(Boolean);
    });
    if (outcomes.length === 2 && outcomes[1].outcomeNumber === 4) {
      result.outcomesAsList.splice(1, 0, '');
    }
  }
  return result;
};
const normalizeDraw = data => {
  const _ref7 = data || {},
    productId = _ref7.productId,
    drawNumber = _ref7.drawNumber,
    regCloseTime = _ref7.regCloseTime,
    drawEvents = _ref7.drawEvents,
    events = _ref7.events;
  if (productId === RACING) {
    return data;
  }
  if (productId && drawNumber) {
    const _events = drawEvents || events;
    if (!Array.isArray(_events) || _events.length === 0) {
      throw new Error('Missing "draw.drawEvents" in response from draw-API.');
    }
    if (_events.some((item, index) => item.eventNumber !== index + 1)) {
    }
    const subProductId = userProduct2SubProductId[data.userProduct];
    return {
      productId,
      subProductId,
      drawNumber,
      regCloseTime,
      events: _events.map(event => _normalizeDrawEvent({
        event,
        productId
      }))
    };
  }
  throw new Error('Failed to normalize draw');
};
const fetchDrawAndPix = async _ref8 => {
  let productId = _ref8.productId,
    drawNumber = _ref8.drawNumber,
    systemType = _ref8.systemType,
    systemCost = _ref8.systemCost,
    rowPrice = _ref8.rowPrice,
    branding = _ref8.branding,
    productSizes = _ref8.productSizes,
    isPixMix = _ref8.isPixMix,
    shouldGenerateNewPix = _ref8.shouldGenerateNewPix;
  const currentDraw = productId === RACING ? await fetchRace(productId, drawNumber) : await fetchDraw(productId, drawNumber);
  const currentPix = await createPix({
    productId,
    drawNumber,
    systemType,
    systemCost,
    rowPrice,
    branding,
    productSizes,
    isPixMix,
    shouldGenerateNewPix
  });
  return {
    drawResponse: normalizeDraw(currentDraw.getData()),
    currentPix
  };
};
setGlobal('svs.components.sport.quickplayModal.services', {
  fetchDrawAndPix
});

 })(window);